import { Trans } from 'react-i18next'

import React, { FunctionComponent } from 'react'
import { VerificationFlowContext, VerificationMethod } from '@afterpaytouch/registration'
import { Grid, Text } from '@afterpaytouch/core'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { useCheckoutSizes } from '../../utils/responsive'

export const getTranslationKey = (isRevealMobile: boolean, context: VerificationFlowContext, method?: VerificationMethod): string => {
  if (typeof method === 'undefined') {
    return ''
  }
  if (context === VerificationFlowContext.Efa) {
    return `verify:sms:descriptionEfa`
  } else {
    return `verify:${method?.toLowerCase()}:${isRevealMobile ? 'descriptionRevealMobile' : 'description'}`
  }
}

interface DescriptionProps {
  method?: VerificationMethod
  isRevealMobile: boolean
  mobile: string
  email?: string
  wasAutoSent: boolean
  context: VerificationFlowContext
}

export const Description: FunctionComponent<DescriptionProps> = ({ method, isRevealMobile, mobile, email = '', wasAutoSent, context }) => {
  const translationKey = getTranslationKey(isRevealMobile, context, method)
  const { textSize } = useCheckoutSizes()
  if (typeof method === 'undefined') {
    return null
  }
  return (
    <Grid>
      <MaskedElement actionName='Verification Code Sent Description'>
        <Text size={textSize} id='verify-code'>
          <Trans i18nKey={translationKey} values={{ mobile, email, context: wasAutoSent ? 'auto' : '' }} components={{ br: <br /> }} />
        </Text>
      </MaskedElement>
    </Grid>
  )
}
